<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M49.62 18.19L20.8 5.44a2 2 0 00-1.9.15 2 2 0 00-.9 1.68V57.5a1.5 1.5 0 003 0V35.93l28.7-14.11a2 2 0 00-.08-3.63zM21 32.59V8.8l25.45 11.27z"/></svg>